import type { Marker } from "mapbox-gl";
import { IMapMarker, LatLng } from "../map-provider.interface";

export class MapboxMarker implements IMapMarker {
    private readonly _marker: Marker;

    private _clickHandler: ((event: MouseEvent) => void) | null = null;

    constructor(marker: Marker) {
        this._marker = marker;
    }

    remove(): void {
        this._marker.remove();
    }

    onClick(handler: () => void): void {
        const element = this._marker.getElement();
        if (this._clickHandler)
            element.removeEventListener("click", this._clickHandler);

        // Stops the click reaching the map, which would close the pop-up the handler opens.
        this._clickHandler = (event: MouseEvent) => {
            event.stopPropagation();
            handler();
        };
        element.addEventListener("click", this._clickHandler);
    }

    getPosition(): LatLng {
        const { lat, lng } = this._marker.getLngLat();
        return { lat, lng };
    }
}
